/* tslint:disable */
/* eslint-disable */
export enum DriverLicenseTypeEnum {
  None = 'None',
  Learners = 'Learners',
  Restricted = 'Restricted',
  Full = 'Full',
  SpecialConditions = 'SpecialConditions'
}
